








































import { ExchangeCustomAwardModal, ExchangeWithdrawModal, GCoinsHistory } from '@/components/gcoins';
import { Geek } from '@/models';
import Vue from 'vue';

export default Vue.extend({
  name: 'GCoinsView',
  props: {
    geek: Object as () => Geek,
  },
  components: {
    ExchangeCustomAwardModal,
    ExchangeWithdrawModal,
    GCoinsHistory,
  },
  methods: {
    openCustomAwardModal() {
      this.$bvModal.show('custom-award-modal');
    },
    openWithdrawModal() {
      this.$bvModal.show('withdraw-modal');
    },
  },
});
